import { formatString } from './formatString';
export function hasInputErrors(inputErrors) {
    return Object.values(inputErrors).some((errors) => errors.length > 0);
}
function isInputElement(element) {
    return ['INPUT', 'SELECT'].includes(element.nodeName);
}
function getInputErrors(el, requiredErrorMessage, typeMismatchErrorMessage, rangeUnderOverflowErrorMessage) {
    const { valueMissing, typeMismatch, rangeUnderflow, rangeOverflow } = el.validity;
    const inputErrors = [];
    if (valueMissing) {
        inputErrors.push(formatString(requiredErrorMessage, [el.dataset.labelText]));
    }
    if (typeMismatch) {
        inputErrors.push(formatString(typeMismatchErrorMessage, [el.dataset.labelText]));
    }
    if (rangeUnderflow || rangeOverflow) {
        inputErrors.push(formatString(rangeUnderOverflowErrorMessage, [el.dataset.labelText]));
    }
    return inputErrors;
}
function getAllInputErrors(elements, requiredErrorMessage, typeMismatchErrorMessage, rangeUnderOverflowErrorMessage) {
    const allInputErrors = {};
    [...elements].filter(isInputElement).forEach((el) => {
        allInputErrors[el.name] = getInputErrors(el, requiredErrorMessage, typeMismatchErrorMessage, rangeUnderOverflowErrorMessage);
    });
    return allInputErrors;
}
export function inputErrorsReducer(inputErrors, action) {
    // Always use this copy to ensure a state update
    const newInputErrors = Object.assign({}, inputErrors);
    switch (action.type) {
        case 'validateAll':
            var { formEl, resourcedTexts } = action;
            return getAllInputErrors(formEl.elements, resourcedTexts.requiredError, resourcedTexts.typeMismatchError, resourcedTexts.typeMismatchError);
        case 'validate':
            var { inputEl, resourcedTexts } = action;
            return Object.assign(Object.assign({}, newInputErrors), { [inputEl.name]: getInputErrors(inputEl, resourcedTexts.requiredError, resourcedTexts.typeMismatchError, resourcedTexts.typeMismatchError) });
        case 'removeAll':
            Object.keys(inputErrors).forEach((key) => {
                newInputErrors[key] = [];
            });
            return newInputErrors;
        case 'remove':
            const { fields } = action;
            fields.forEach((field) => {
                newInputErrors[field] = [];
            });
            return newInputErrors;
    }
}
